// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import { FaTelegram, FaDiscord, FaTwitter, FaFacebook } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { useViewport } from '../hooks/useViewport';

export default function Footer() {
  const [modal, setModal] = useState(null);
  const { width, height } = useViewport();
  const location = useLocation();
  const navigate = useNavigate();

  const isLandscape = width > height;
  const hideFooterAds = isLandscape && width < 1000 && height < 750;

  // Open the correct modal based on the URL
  useEffect(() => {
    switch (location.pathname) {
      case '/list_your_game':
        setModal('list_your_game');
        break;
      default:
        setModal(null);
    }
  }, [location.pathname]);

useEffect(() => {
  try {
    document.querySelectorAll("ins.adsbygoogle").forEach(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    });
  } catch {}
}, []);


  const closeModal = () => {
    setModal(null);

    // If we were on a modal-specific route, go back to home (or wherever you prefer)
    if (['/list_your_game'].includes(location.pathname)) {
      navigate('/');
    }
  };

  // Helper to navigate to the right route (URL controls the modal)
  const openModalRoute = (type) => {
    switch (type) {
      case 'list_your_game':
        navigate('/list_your_game');
        break;
      default:
        break;
    }
  };

  return (
    <>
      {/* Fixed dark footer bar */}
      <footer className="fixed inset-x-0 bottom-0 z-50 bg-slate-950 border-t border-slate-800 text-xs text-slate-400">
        <div className="mx-auto max-w-7xl px-4 py-2 flex flex-col gap-2">
          {!hideFooterAds && (
            <>
              {/* MOBILE 300x50 AD – only < sm */}
              <div className="flex justify-center sm:hidden">
                <div className="w-[300px] h-[50px] bg-slate-900 rounded-xl border border-slate-800 flex items-center justify-center">
                  <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1487974375505356"
                      crossorigin="anonymous"></script>
                  <ins class="adsbygoogle"
                style={{display:"block"}}
                      data-ad-client="ca-pub-1487974375505356"
                      data-ad-slot="3468081063"
                      data-ad-format="auto"
                      data-full-width-responsive="true"></ins>
                  <script>
                      (adsbygoogle = window.adsbygoogle || []).push({});
                  </script>
                </div>
              </div>

              {/* TABLET / DESKTOP 728x90 AD – sm to xl (hidden on 2xl+) */}
              <div className="hidden sm:flex 2xl:hidden justify-center w-full">
                <div className="w-[728px] h-[90px] bg-slate-900 rounded-xl border border-slate-800 flex items-center justify-center max-w-full">
                 <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1487974375505356"
                        crossorigin="anonymous"></script>
                    <ins class="adsbygoogle"
                style={{display:"block"}}
                        data-ad-client="ca-pub-1487974375505356"
                        data-ad-slot="3728592057"
                        data-ad-format="auto"
                        data-full-width-responsive="true"></ins>
                    <script>
                        (adsbygoogle = window.adsbygoogle || []).push({});
                    </script>
                </div>
              </div>
            </>
          )}

          {/* Footer content row: copyright + links + socials */}
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            {/* Left side: copyright + legal links */}
            <div className="flex flex-wrap items-center gap-2">
              <span>© {new Date().getFullYear()} Kepithor Studios</span>
              <span className="hidden sm:inline text-slate-600">|</span>

              <button
                onClick={() => navigate('privacy')}
                className="underline underline-offset-2 hover:text-emerald-300"
              >
                Privacy Policy
              </button>
              <span className="text-slate-600">|</span>
              <button              
                onClick={() => navigate('terms')}
                className="underline underline-offset-2 hover:text-emerald-300"
              >
                Terms
              </button>
              <span className="text-slate-600">|</span>
              <button
                onClick={() => navigate('eula')}
                className="underline underline-offset-2 hover:text-emerald-300"
              >
                Eula
              </button>
            </div>

            {/* Right side: social icons */}
            <div className="flex gap-4 text-xl sm:text-2xl sm:ml-auto justify-center sm:justify-end">

              <button
                onClick={() => openModalRoute('list_your_game')}
                className="inline-flex items-center justify-center px-3 py-1 text-sm font-medium rounded-xl bg-emerald-500 text-slate-900 hover:bg-emerald-400 transition-colors"
            >
                List your Game
              </button>

              
            

              <a
                href="https://t.me/Kepithor"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-400"
              >
                <FaTelegram />
              </a>
              <a
                href="https://discord.gg/4sGRU53pYw"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-400"
              >
                <FaDiscord />
              </a>
              <a
                href="https://twitter.com/KepithorStudios"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-500"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.facebook.com/KepithorStudios/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {modal && (
        <div
          onClick={closeModal}
          className="fixed inset-0 z-[2000] bg-black/60 flex items-center justify-center p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative bg-slate-900 text-slate-100 border border-slate-700 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto p-6 shadow-xl shadow-emerald-500/20"
          >
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-slate-400 hover:text-slate-100 text-xl"
            >
              &times;
            </button>

            

            
            {modal === 'list_your_game' && (
              <>
                <b></b>
                <p>To list your game please email us from an email matching the domain of your game/studio.</p>
                <p>team@kepithorstudios.com</p>
              </>
            )}


          </div>
        </div>
      )}
    </>
  );
}
